import { render, staticRenderFns } from "./finance-general.vue?vue&type=template&id=1b969b16&scoped=true"
import script from "./finance-general.vue?vue&type=script&lang=js"
export * from "./finance-general.vue?vue&type=script&lang=js"
import style0 from "./finance-general.vue?vue&type=style&index=0&id=1b969b16&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b969b16",
  null
  
)

export default component.exports